import { useState, useEffect } from "react";
import "./ServicesWeOffer.css";

import industryServicesIcon1 from "../../../../Assets/Icons/industryServicesIcon1.svg";
import industryServicesIcon2 from "../../../../Assets/Icons/industryServicesIcon2.svg";
import industryServicesIcon3 from "../../../../Assets/Icons/industryServicesIcon3.svg";
import industryServicesIcon4 from "../../../../Assets/Icons/industryServicesIcon4.svg";
import industryServicesIcon5 from "../../../../Assets/Icons/industryServicesIcon5.svg";
import industryServicesIcon6 from "../../../../Assets/Icons/industryServicesIcon6.svg";
import industryServicesIcon7 from "../../../../Assets/Icons/industryServicesIcon7.svg";
import industryServicesIcon8 from "../../../../Assets/Icons/industryServicesIcon8.svg";
import industryServicesIcon9 from "../../../../Assets/Icons/industryServicesIcon9.svg";
import industryServicesIcon10 from "../../../../Assets/Icons/industryServicesIcon10.svg";
import industryServicesIcon11 from "../../../../Assets/Icons/industryServicesIcon11.svg";
import industryServicesIcon12 from "../../../../Assets/Icons/industryServicesIcon12.svg";
import industryServicesIcon13 from "../../../../Assets/Icons/industryServicesIcon13.svg";
import industryServicesIcon14 from "../../../../Assets/Icons/industryServicesIcon14.svg";
import industryServicesIcon15 from "../../../../Assets/Icons/industryServicesIcon15.svg";
import industryServicesIcon16 from "../../../../Assets/Icons/industryServicesIcon16.svg";
import analyticsAreaServicesIcon1 from "../../../../Assets/Icons/analyticsAreaServicesIcon1.svg";
import analyticsAreaServicesIcon2 from "../../../../Assets/Icons/analyticsAreaServicesIcon2.svg";
import analyticsAreaServicesIcon3 from "../../../../Assets/Icons/analyticsAreaServicesIcon3.svg";
import analyticsAreaServicesIcon4 from "../../../../Assets/Icons/analyticsAreaServicesIcon4.svg";
import analyticsAreaServicesIcon5 from "../../../../Assets/Icons/analyticsAreaServicesIcon5.svg";
import analyticsAreaServicesIcon6 from "../../../../Assets/Icons/analyticsAreaServicesIcon6.svg";
import closeIcon from "../../../../Assets/Icons/close-icon.svg";
import checkRightIcon from "../../../../Assets/Icons/check-right-icon.svg";

const ServicesWeOffer = () => {
  const [activeTab, setActiveTab] = useState("industry");
  const [selectedService, setSelectedService] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [showAllCards, setShowAllCards] = useState(false);

  // Detect if screen is small (≤768px)
  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Reset "show all" state when tab or screen size changes
  useEffect(() => {
    setShowAllCards(false);
  }, [activeTab, isSmallScreen]);

  useEffect(() => {
    if (selectedService) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedService]);

  const industryServices = [
    {
      id: 1,
      title: "Healthcare analytics",
      description:
        "Helping care teams identify patterns without delaying treatment.",
      icon: industryServicesIcon1,
      details: [
        "See patient flow throughout busy departments.",
        "Learn about delays before they impact care.",
        "Track outcomes over time, not snap shots.",
        "Reduce the reporting chaos across systems.",
        "Support compliance without creating friction.",
      ],
    },
    {
      id: 2,
      title: "Banking analytics",
      description: "Making sense of financial data that rarely sits together.",
      icon: industryServicesIcon2,
      details: [
        "See channel patterns for transactions.",
        "Identify operational risks before they get out of hand.",
        "Understand customer behaviour, not just balances.",
        "Simplify compliance and internal reporting.",
        "Prevent spreadsheet overload of tracking performance.",
      ],
    },
    {
      id: 3,
      title: "Insurance analytics",
      description:
        "Turning scattered policy data into better decisions.",
      icon: industryServicesIcon3,
      details: [
        "Understand why claims are slow.",
        "Surface unusual activity earlier.",
        "Monitor the performance of policies over time.",
        "Support underwriting with Real Trends.",
        "Decrease reporting friction between teams.",
      ],
    },
    {
      id: 4,
      title: "Lending analytics",
      description:
        "Helping lenders to act before the problem shows up.",
      icon: industryServicesIcon4,
      details: [
        "See borrower behaviour change at an early stage.",
        "Monitor the health of the portfolio on a continuous basis.",
        "Understand Risk Beyond Credit Scores.",
        "Gain more confidence in review and approval.",
        "Reduce bottlenecks of manual analysis.",
      ],
    },
    {
      id: 5,
      title: "Investment analytics",
      description:
        "Helping investment teams cut through the noise.",
      icon: industryServicesIcon5,
      details: [
        "Track clearly the performance of portfolio over time.",
        "Compare the risk and actual outcomes.",
        "Understand asset behaviour patterns.",
        "Improve the clarity of communication to investors.",
        "Support capable allocation decisions.",
      ],
    },
    {
      id: 6,
      title: "Manufacturing analytics",
      description:
        "Bringing clarity to noisy production environments.",
      icon: industryServicesIcon6,
      details: [
        "See where production is actually slowing.",
        "Understand the recurring causes of downtime.",
        "Track quality trends, not individual defects.",
        "Improve visibility of supply chain every day.",
        "Facilitate realistic capacity planning.",
      ],
    },
    {
      id: 7,
      title: "Retail analytics",
      description:
        "Understanding what really moves products.",
      icon: industryServicesIcon7,
      details: [
        "See how customers are actually buying.",
        "Track movement of inventory in real-time.",
        "Clearly understand promotion impact.",
        "Predict demand before shelves are empty.",
        "Reduce waste and losses in stock.",
      ],
    },
    {
      id: 8,
      title: "Transportation and logistics analytics",
      description:
        "Making fast-moving operations visible.",
      icon: industryServicesIcon8,
      details: [
        "See where deliveries fall apart.",
        "Have a clear understanding of route inefficiencies.",
        "Track costs as they shift.",
        "Identify delays prior to customers doing so.",
        "Support better planning decisions.",
      ],
    },
    {
      id: 9,
      title: "Real estate analytics",
      description:
        "Reducing uncertainty in long cycle decisions.",
      icon: industryServicesIcon9,
      details: [
        "Track property performance through the years.",
        "Have an Occupancy Trends understanding clearly.",
        "See cost patterns early.",
        "Support pricing using actual data.",
        "Improve confidence of investment.",
      ],
    },
    {
      id: 10,
      title: "Professional services analytics",
      description:
        "Helping teams see beyond the billable hours.",
      icon: industryServicesIcon10,
      details: [
        "Understand actual project profitability.",
        "See where time disappears.",
        "Track utilisation without micro management.",
        "Improve accuracy of forecasting over time.",
        "Undermine leadership decision making.",
      ],
    },
    {
      id: 11,
      title: "Energy & utilities analytics",
      description:
        "Turning continuous data into usable insight.",
      icon: industryServicesIcon11,
      details: [
        "See consumption patterns as they change.",
        "Identify losses before they become large.",
        "Assistance of demand forecasting decisions.",
        "Improve the visibility of operational performance.",
        "Enable long term planning of infrastructure.",
      ],
    },
    {
      id: 12,
      title: "Oil & gas analytics",
      description:
        "Spotting inefficiencies before they get out of hand.",
      icon: industryServicesIcon12,
      details: [
        "Track output trends clearly.",
        "Understand operational risk indicators.",
        "Monitor performance among sites.",
        "Support Compliance without Delays.",
        "Enhance cost control decisions.",
      ],
    },
    {
      id: 13,
      title: "Telecoms analytics",
      description:
        "Helping networks cope with constant pressure.",
      icon: industryServicesIcon13,
      details: [
        "Understand the behaviour of network performance.",
        "Track customer usage patterns.",
        "Identify churn risk earlier.",
        "Support the planning of capacity decisions.",
        "Improve service reliability insight.",
      ],
    },
    {
      id: 14,
      title: "Education analytics",
      description:
        "Helping institutions learn from their data every day.",
      icon: industryServicesIcon14,
      details: [
        "See student engagement patterns.",
        "Monitor performance beyond grades.",
        "Understand course effectiveness unambiguously.",
        "Assist in planning and reporting.",
        "Enable improved academic decisions.",
      ],
    },
    {
      id: 15,
      title: "Travel and hospitality",
      description:
        "Staying ahead of changing demand.",
      icon: industryServicesIcon15,
      details: [
        "Track changes in the behaviour of bookings.",
        "Understand seasonal demand fluctuations.",
        "Improve pricing confidence.",
        "See guest behaviour trends.",
        "Support operation readiness.",
      ],
    },
    {
      id: 16,
      title: "Media & entertainment analytics",
      description:
        "Understanding audiences as tastes are shifting.",
      icon: industryServicesIcon16,
      details: [
        "See patterns of content performances.",
        "Track engagement beyond views.",
        "Understand where the attention drops.",
        "To support monetisation strategy choices.",
        "Enhance the confidence of planning content.",
      ],
    },
  ];

  const analyticsAreaServices = [
    {
      id: 1,
      title: "Financial analytics",
      description:
        "When reports are looking complete but there is a lack of confidence.",
      icon: analyticsAreaServicesIcon1,
      details: [
        "Understand where revenue is really coming from, and where it leaks away unnoticed.",
        "See cost increase early rather than finding out too late.",
        "Compare planned budgets to what is really happening.",
        "Monitor profitability by product, team or market.",
        "Support financial decisions with clear knowledge of tradeoffs.",
      ],
    },
    {
      id: 2,
      title: "Supply chain analytics",
      description:
        "When delays and shortages continue to repeat for no apparent reason.",
      icon: analyticsAreaServicesIcon2,
      details: [
        "See where materials and products are slowed down at stages.",
        "Understand what partners or steps cause recurring bottlenecks.",
        "Track inventory movement rather than making assumptions.",
        "Identify risks before customers are affected by disruptions.",
        "Improve planning without constantly firefighting.",
      ],
    },
    {
      id: 3,
      title: "Sales & product analytics",
      description: "When effort is high but growth feels unpredictabl",
      icon: analyticsAreaServicesIcon3,
      details: [
        "Recognize how customers do really flow through the funnel.",
        "See where interest is dropping before conversion occurs.",
        "Track which features drive usage & retention.",
        "Relate sales activity with actual product results.",
        "Make roadmap decisions based on evidence not opinions.",
      ],
    },
    {
      id: 4,
      title: "Customer analytics",
      description: "When users behave differently than expected.",
      icon: analyticsAreaServicesIcon4,
      details: [
        "See how customers interact between channels and time.",
        "Understand why churn occurs rather than guess.",
        "Identify patterns behind loyalty, repeat usage.",
        "Aside from surface friction, customer points that customers never explicitly report.",
        "Improve experience with informed and measured changes.",
      ],
    },
    {
      id: 5,
      title: "Asset analytics",
      description: "When assets exist but their value feels unclear",
      icon: analyticsAreaServicesIcon5,
      details: [
        "Track how exactly assets are used day to day.",
        "Understand maintenance patterns and Hidden Inefficiencies.",
        "Detect underutilised or ageing assets at an early stage.",
        "Support repair versus replacement decisions.",
        "Plan long term asset with confidence.",
      ],
    },
    {
      id: 6,
      title: "HR analytics",
      description:
        "When teams grow but clarity does not",
      icon: analyticsAreaServicesIcon6,
      details: [
        "Understand workforce trends more than headcount numbers.",
        "See early signs of burnout or disengagement.",
        "Track retaining patterns in roles and teams.",
        "Support hiring decisions using history.",
        "Improve workforce planning - without relying on instinct.",
      ],
    },
  ];

  const currentServices =
    activeTab === "industry" ? industryServices : analyticsAreaServices;

  // On large screens: always show all
  // On small screens: show 6 or all based on toggle
  const visibleServices =
    isSmallScreen && !showAllCards
      ? currentServices.slice(0, 6)
      : currentServices;

  const handleOpenModal = (service) => {
    setSelectedService(service);
  };

  const handleCloseModal = () => {
    setSelectedService(null);
  };

  const toggleShowAllCards = () => {
    setShowAllCards(!showAllCards);
  };

  return (
    <div id="services" className="services-we-offer">
      <div className="services-we-offer__header">
        <h2 className="services-we-offer__title">
          Where Our Data Analytics Actually Helps
        </h2>
        <p className="services-we-offer__description">
          Data analytics is a term that means very different things depending on
          the industry. In some places, it is about risk. In others, speed,
          efficiency or visibility. We design analytics around the decisions
          people find difficult to make on a day-to-day basis and not around the
          generic dashboards or vanity metrics.
        </p>
      </div>

      <div className="services-we-offer__tabs">
        <button
          className={`services-we-offer__tab ${
            activeTab === "industry" ? "services-we-offer__tab--active" : ""
          }`}
          onClick={() => setActiveTab("industry")}
        >
          By Industry
        </button>
        <button
          className={`services-we-offer__tab ${
            activeTab === "analytics" ? "services-we-offer__tab--active" : ""
          }`}
          onClick={() => setActiveTab("analytics")}
        >
          By Analytics Area
        </button>
      </div>

      <div className="services-we-offer__grid">
        {visibleServices.map((service) => (
          <div key={service.id} className="services-we-offer__card">
            <div className="services-we-offer__icon">
              <img
                src={service.icon}
                alt=""
                className="services-we-offer__icon-svg"
              />
            </div>
            <h3 className="services-we-offer__card-title">{service.title}</h3>
            <p className="services-we-offer__card-description">
              {service.description}
            </p>
            <button
              className="services-we-offer__card-button"
              onClick={() => handleOpenModal(service)}
            >
              +
            </button>
          </div>
        ))}
      </div>

      {/* See More / See Less — only on small screens */}
      {isSmallScreen && currentServices.length > 6 && !showAllCards && (
        <div className="services-we-offer__see-more">
          <button
            className="services-we-offer__see-more-button"
            onClick={toggleShowAllCards}
          >
            See More <span className="arrow-down">▼</span>
          </button>
        </div>
      )}

      {isSmallScreen && currentServices.length > 6 && showAllCards && (
        <div className="services-we-offer__see-more">
          <button
            className="services-we-offer__see-more-button"
            onClick={toggleShowAllCards}
          >
            See Less <span className="arrow-up">▲</span>
          </button>
        </div>
      )}

      {/* Modal */}
      {selectedService && (
        <div
          className="data-analysis__modal-overlay"
          onClick={handleCloseModal}
        >
          <div
            className="data-analysis__services-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="data-analysis__modal-header">
              <div className="modal-icon-wrapper">
                <div className="modal-icon">
                  <img
                    src={selectedService.icon}
                    alt=""
                    className="modal-icon-svg"
                  />
                </div>
              </div>
              <button
                className="data-analysis__modal-close"
                onClick={handleCloseModal}
              >
                <img
                  src={closeIcon}
                  alt="Close"
                  className="data-analysis__modal-close-icon"
                />
              </button>
            </div>
            <h2 className="modal-title">{selectedService.title}</h2>
            <ul className="modal-list">
              {selectedService.details.map((detail, index) => (
                <li key={index} className="modal-list-item">
                  <span className="checkmark">
                    <img
                      src={checkRightIcon}
                      alt=""
                      className="checkmark-icon"
                    />
                  </span>
                  {detail}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicesWeOffer;
